import { render, staticRenderFns } from "./TransportCode.vue?vue&type=template&id=623e6c26&"
import script from "./TransportCode.vue?vue&type=script&lang=js&"
export * from "./TransportCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports